import { render, staticRenderFns } from "./ConsignmentDocuments.vue?vue&type=template&id=5844bf47&scoped=true"
import script from "./ConsignmentDocuments.vue?vue&type=script&lang=js"
export * from "./ConsignmentDocuments.vue?vue&type=script&lang=js"
import style0 from "./ConsignmentDocuments.vue?vue&type=style&index=0&id=5844bf47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844bf47",
  null
  
)

export default component.exports